var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('home-page-layout',[_c('div',{staticClass:"mt-8",style:({ maxWidth: '1000px', margin: 'auto' })},[_c('account-tabs'),_c('v-card',{attrs:{"flat":"","outlined":""}},[_c('v-card-text',[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }